import { render, staticRenderFns } from "./EventActions.vue?vue&type=template&id=bed2ab9a"
import script from "./EventActions.vue?vue&type=script&lang=js"
export * from "./EventActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports